export type ElectricityBillingMode =
  | "flat_per_night"
  | "per_kwh"
  | "flat_with_included_kwh";

/** Abrechenbare kWh-Menge (entspricht api/core/electricity_pricing.py). */
export function computeBillableElectricityKwh(
  mode: ElectricityBillingMode,
  nights: number,
  electricityKwh: number | null | undefined,
  includedKwhPerNight: number | null | undefined,
): number | null {
  if (electricityKwh == null || electricityKwh <= 0) return null;
  if (mode === "per_kwh") return electricityKwh;
  if (mode === "flat_with_included_kwh") {
    const included = (includedKwhPerNight ?? 0) * nights;
    const overage = electricityKwh - included;
    return overage > 0 ? overage : null;
  }
  return null;
}

export function electricityModeNeedsKwh(mode: ElectricityBillingMode): boolean {
  return mode === "per_kwh" || mode === "flat_with_included_kwh";
}
